module.exports = __webpack_public_path__ + "static/img/17.2005885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/17.jpg
// module id = ZkY4
// module chunks = 0